var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ExamQuestionBank-header"},[_c('div',{staticClass:"w"},[_c('SecondHead',{attrs:{"activeIndex":"8","textColor":"#333","color":"#333"}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }